@if (block.data.mainQuote) {
    <figure class="testimonial">
        @if (block.data.includeImage && block.data.image) {
            <img class="testimonial__image" [src]="block.data.image" alt="" />
        }

        <blockquote class="testimonial__quote-container">
            <p class="testimonial__main-quote">{{ block.data.mainQuote }}</p>
            @if (block.data.subQuote) {
                <p class="testimonial__sub-quote">{{ block.data.subQuote }}</p>
            }
        </blockquote>

        @if (block.data.authorName) {
            <figcaption class="testimonial__author-container">
                <p class="testimonial__author">{{ block.data.authorName }}</p>

                @if (block.data.authorName) {
                    <p class="testimonial__author-role">{{ block.data.authorRole }}</p>
                }
            </figcaption>
        }
    </figure>
}
